// extracted by mini-css-extract-plugin
module.exports = {"medications":"medications_medications__eW0XM","item":"medications_item__2wuP8","tick":"medications_tick__1aWOy"};